import styled from "@emotion/styled";
import { Col, Modal, Row, Select, Spin, message } from "antd";
import Button from "atoms/Button";
import COLORS from "common/Colors";
import { LEAVE_ICON } from "common/Constants";
import { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import LeaveDonutChart from "./LeaveDonutChart";
import { reduce } from "lodash";
import { connect } from "react-redux";
import {
  getAllDepartmentList,
  getClientid,
  getUserList,
  getUserRoleId,
} from "redux/selectors";

const StyledModal = styled(Modal)`
  width: 700px !important;
  .ant-modal-body {
    height: 500px;
    max-height: 500px;
    overflow-y: auto;
  }
  .ant-modal-header {
    text-transform: uppercase;
    max-width: 95%;
  }
`;

const StyledCol = styled(Col)`
  margin-bottom: 10px;
`;

const ButtonOutlined = styled(Button)`
  padding: 5px 20px;
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 5px;
  background: transparent;
  font-weight: normal;
  color: ${COLORS.PRIMARY};
  white-space: nowrap;
  &:hover,
  &:focus {
    border: 1px solid ${COLORS.PRIMARY};
    background: #f1f3f4;
    color: ${COLORS.PRIMARY};
  }
  @media (max-width: 900px) {
    margin: 10px 0px;
  }
`;

const StyledSelect = styled(Select)`
  padding-bottom: 20px;
  .ant-select-arrow {
    top: 30% !important;
  }
`;

function DepartmentStaffLeaveBalance({
  displayModal,
  toggleModal,
  leaveTypeId,
  leaveName,
  selectedDepartmentId,
  leaveCategoryList,
  allDepartmentList,
  userList,
  clientId,
  leaveList,
  leaveCatgeory,
  filterDepartment,
  all,
  storeUserData,
  availableLeaves,
  departmentStatistics,
}) {
  const [displayLeaveReportLoader, toggleLeaveReportLoader] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [departmentNames, setDepartmentNames] = useState([]);
  const [filter, setFilter] = useState([]);
  const [CSVDepartmentLeave, setCSVDepartmentLeave] = useState([]);
  const [departmentLeave, setDepartmentLeave] = useState([]);
  const [showMemberList, setShowMemberList] = useState(false);
  const csvLinkDepartment = useRef();

  const filteredUserList = userList.filter((user) => user.statusid === "1");

  useEffect(() => {
    setFilteredUsers([]);
    setDepartmentNames([]);
    setShowMemberList(false);
    setFilter([]);
    setDepartmentLeave([]);
  }, [displayModal]);

  const selecetDepartment = (ids) => {
    let leaveStatistics = {};

    const teamFilteredUserList = filteredUserList.filter((user) =>
      ids.map(Number).includes(Number(user.basedepartmentid))
    );

    teamFilteredUserList.forEach((user) => {
      leaveStatistics[user.userid] = {
        available: 0,
        consumed: 0,
        carryforward: 0,
      };
    });

    ids.forEach((id) => {
      const approvedLeaves = availableLeaves.filter(
        (item) => Number(item.categoryid) === Number(id)
      );
      const deptItems = approvedLeaves[0]?.items || [];

      deptItems.forEach((leave) => {
        const userId = leave.userid;
        if (!leaveStatistics[userId]) {
          leaveStatistics[userId] = {
            available: 0,
            consumed: 0,
            carryforward: 0,
          };
        }
        leaveStatistics[userId].available += Number(leave.available || 0);
        leaveStatistics[userId].consumed += Number(leave.consumed || 0);
        leaveStatistics[userId].carryforward += Number(
          leave.carry_forward || 0
        );
      });
    });

    const updatedLeaveData = teamFilteredUserList.map((user) => ({
      categoryName: user.fullname,
      categoryid: user.userid,
      data: [
        {
          type: "available",
          value: leaveStatistics[user.userid]?.available || 0,
          carryforward: leaveStatistics[user.userid]?.carryforward || 0,
        },
        {
          type: "consumed",
          value: leaveStatistics[user.userid]?.consumed || 0,
        },
      ],
    }));

    setDepartmentLeave(updatedLeaveData);
  };

  const showDepartmentMemberList = (ids) => {
    selecetDepartment(ids);
    setShowMemberList(true);
    setFilteredUsers(ids);
    setFilter([]);
  };

  const employeeOptions = filteredUserList.filter((user) =>
    filteredUsers.map(Number).includes(Number(user.basedepartmentid))
  );

  const prepareCSV = async () => {
    if (showMemberList) {
      if (departmentLeave.length > 0) {
        setCSVDepartmentLeave(
          reduce(
            departmentLeave
              .filter((leave) => {
                if (filter && filter.length)
                  return filter.includes(leave.categoryid);
                return true;
              })
              .filter((value) => {
                const available =
                  value.data.find((i) => i.type === "available")?.value || 0;
                const consumed =
                  value.data.find((i) => i.type === "consumed")?.value || 0;
                return available !== 0 || consumed !== 0;
              }),
            (result, leave) => {
              const userObj = filteredUserList.find(
                (u) => u.userid === leave.categoryid
              );
              const userDept = allDepartmentList.find(
                (d) =>
                  Number(d.department_id) === Number(userObj?.basedepartmentid)
              );
              result.push({
                ...(filteredUsers.length > 1 && {
                  Department: userDept?.department_name || "-",
                }),
                Name: leave.categoryName,
                "Available Leaves": leave.data[0].value,
                "Consumed Leaves": leave.data[1].value,
                CF: leave.data[0].carryforward,
              });
              return result;
            },
            []
          )
        );
        setTimeout(() => csvLinkDepartment.current.link.click());
      } else {
        message.error("No data available to download.");
      }
    } else {
      if (availableLeaves.length > 0) {
        setCSVDepartmentLeave(
          reduce(
            availableLeaves.filter((value) => {
              const available =
                value.data.find((i) => i.type === "available")?.value || 0;
              const consumed =
                value.data.find((i) => i.type === "consumed")?.value || 0;
              return available !== 0 || consumed !== 0;
            }),
            (result, leave) => {
              result.push({
                "Department ID": leave.categoryid,
                "Department Name": leave.categoryName,
                "Available Leaves": leave.data[0].value,
                "Consumed Leaves": leave.data[1].value,
                CF: leave.data[0].carryforward,
              });
              return result;
            },
            []
          )
        );
        setTimeout(() => csvLinkDepartment.current.link.click());
      } else {
        message.error("No data available to download.");
      }
    }
  };

  function findLeaveCategoryName(leaveCategoryList, leaveTypeId) {
    const leaveCategory = leaveCategoryList?.find(
      (category) => category?.leave_category_id === leaveTypeId
    );
    return leaveCategory
      ? leaveCategory?.leave_category_name
      : "Category not found";
  }

  const leaveCategoryName = findLeaveCategoryName(
    leaveCategoryList,
    leaveTypeId
  );

  return (
    <>
      <StyledModal
        title={
          showMemberList && departmentNames.length > 0
            ? `${departmentNames.join(", ")} - ${leaveCategoryName} Report`
            : `Overall ${leaveCategoryName} Report`
        }
        visible={displayModal}
        onCancel={toggleModal}
        footer={null}
      >
        <Spin spinning={displayLeaveReportLoader}>
          <Row gutter={16}>
            <Col span={8}>
              <p>Department</p>
              <StyledSelect
                mode="multiple"
                showSearch
                allowClear
                maxTagCount="responsive"
                style={{ width: "100%" }}
                placeholder="Search Department"
                optionFilterProp="label"
                options={allDepartmentList.map((dept) => ({
                  label: dept.department_name,
                  value: dept.department_id,
                }))}
                value={filteredUsers}
                onChange={(selectedIds) => {
                  if (selectedIds.length === 0) {
                    setFilteredUsers([]);
                    setDepartmentNames([]);
                    setShowMemberList(false);
                    setFilter([]);
                    setDepartmentLeave([]);
                  } else {
                    const names = allDepartmentList
                      .filter((dept) =>
                        selectedIds.includes(dept.department_id)
                      )
                      .map((dept) => dept.department_name);
                    setDepartmentNames(names);
                    showDepartmentMemberList(selectedIds);
                  }
                }}
              />
            </Col>

            <Col span={8}>
              <p>Employee</p>
              <StyledSelect
                mode="multiple"
                showSearch
                style={{ width: "100%" }}
                placeholder="All"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                options={employeeOptions.map((u) => ({
                  label: u.fullname,
                  value: u.userid,
                }))}
                value={filter}
                onChange={setFilter}
                disabled={!showMemberList}
              />
            </Col>

            <Col
              span={8}
              style={{ justifyContent: "flex-end", display: "flex" }}
            >
              <ButtonOutlined
                onClick={prepareCSV}
                disabled={
                  showMemberList
                    ? departmentLeave.length === 0
                    : availableLeaves?.length === 0
                }
              >
                Export CSV file
              </ButtonOutlined>
              <CSVLink
                header={[
                  { label: "Employee ID" },
                  { label: "Name" },
                  { label: "Available Leaves" },
                  { label: "Consumed Leaves" },
                  { label: "Total Leaves" },
                ]}
                data={CSVDepartmentLeave}
                filename={"Department Leave List.csv"}
                asyncOnClick={true}
                ref={csvLinkDepartment}
              />
            </Col>
          </Row>

          {showMemberList ? (
            <Row gutter={16}>
              {Array.isArray(departmentLeave) &&
                departmentLeave
                  .filter((leave) => {
                    if (filter && filter.length)
                      return filter.includes(leave.categoryid);
                    return true;
                  })
                  .filter((value) => {
                    const available =
                      value?.data?.find((i) => i.type === "available")?.value ||
                      0;
                    const consumed =
                      value?.data?.find((i) => i.type === "consumed")?.value ||
                      0;
                    return available !== 0 || consumed !== 0;
                  })
                  .map((value, index) => (
                    <StyledCol md={12} sm={24} xs={24} key={index}>
                      <LeaveDonutChart
                        iconName={LEAVE_ICON[7]}
                        title={value.categoryName}
                        data={value.data}
                        leaveId={leaveTypeId}
                      />
                    </StyledCol>
                  ))}
            </Row>
          ) : (
            <Row gutter={16}>
              {Array.isArray(availableLeaves) &&
                availableLeaves
                  .filter((value) => {
                    const available =
                      value?.data?.find((i) => i.type === "available")?.value ||
                      0;
                    const consumed =
                      value?.data?.find((i) => i.type === "consumed")?.value ||
                      0;
                    return available !== 0 || consumed !== 0;
                  })
                  .map((value, index) => (
                    <StyledCol
                      md={12}
                      sm={24}
                      xs={24}
                      key={index}
                      onClick={() => {
                        const dept = allDepartmentList?.find(
                          (d) => d.department_id === value.categoryid
                        );
                        setDepartmentNames([dept?.department_name || ""]);
                        showDepartmentMemberList([value.categoryid]);
                      }}
                    >
                      <LeaveDonutChart
                        iconName={LEAVE_ICON[7]}
                        title={value.categoryName}
                        data={value.data}
                        leaveId={leaveTypeId}
                      />
                    </StyledCol>
                  ))}
            </Row>
          )}
        </Spin>
      </StyledModal>
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  allDepartmentList: getAllDepartmentList(state),
  userList: getUserList(state),
  clientId: getClientid(state),
});

export default connect(mapStateToProps, null)(DepartmentStaffLeaveBalance);
